import React, {
	 useEffect, useState
}from "react"
import CustomSelect from "../../components/CustomSelect"
import './style.css'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	accountingPeriodActions
}from "./store/actions"
import {
	DatePicker, Select, Typography
}from "antd"
import moment from "moment"

const AccountingPeriod = (props) => {
	function getYear(){
		const date = new Date()
		if (date.getMonth() == 11){
			date.setFullYear(date.getFullYear() + 1)
			date.setMonth(0)
			date.setDate(1)
			return date
		}
		return date
	}
	const { accountingPeriod, setAccountingPeriod, allowYearPickerClear, setAccountPeriodDate, showTitle = true, order = false, className = null, isBase = false, setNotice } = props
	const { list } = useSelector(state => state.accountingPeriodReducer)
	const [year, setYear] = useState(getYear())
	const [localList, setLocalList] = useState(null)
	const [componentUpdated, setComponentUpdated] = useState(true)
	const dispatch = useDispatch()
	const getList = values => {
		dispatch(accountingPeriodActions.getList(values))
	}
	useEffect(() => {
	  getList({ year: year ? moment(year).year(): null })
	}, [year])

	useEffect(() => {
	  return () => {
			setComponentUpdated(true)
			setLocalList(null)
			dispatch(accountingPeriodActions.clear())
		}
	}, [])

	useEffect(() => {
		if (componentUpdated && list!==null){
			setLocalList(list.slice(0))
			setComponentUpdated(false)
		}
		else if (list == null){
			setLocalList(null)
			setComponentUpdated(true)
		}
	  }, [list])

	useEffect(() => {
		if (localList != null && localList.length > 0){
			if (order)
				localList.sort((first, second) => (first.startDate > second.startDate ? 1: -1))
			setAccountingPeriod(localList[0]?.id)
			if (localList[0]?.endDate && setAccountPeriodDate)
				setAccountPeriodDate(localList[0]?.endDate)
			if (localList[0]?.notice && setNotice)
				setNotice(localList[0]?.notice)
		}
		else {
			if (setAccountPeriodDate)
				setAccountPeriodDate(null)
			if (setNotice)
				setNotice(null)
			setAccountingPeriod(null)
		}
	}, [localList])

	const MapDate = (startDate, endDate) => {
		return isBase
			? `На ${ moment.parseZone(endDate)?.format('DD.MM.YYYY') }`
			: (<span title={ `На ${ moment.parseZone(endDate)?.format('DD.MM.YYYY') }` }>
				{ `${ moment.parseZone(startDate)?.format('DD/MM') } - ${ moment.parseZone(endDate)?.format('DD/MM') }` }
			</span>)
	}

	return (
		<div className={ className ?? "accounting-period" }>
			{ showTitle?
				(<Typography.Text style={ { marginRight: "10px" } }>
				Отчётный период:
				</Typography.Text>)
				: null }
			<CustomSelect
				allowClear
				showSearch
				className="select-accounting-period"
				disabled={ Boolean(!localList?.length) }
				filterOption={ false }
				placeholder="Выберите отчётный период"
				value={ accountingPeriod }
				onChange={ (value) => {
					setAccountingPeriod(value)
					if (value && setAccountPeriodDate)
						setAccountPeriodDate(list.find(period => period.id == value)?.endDate)
					if (value && setNotice)
						setNotice(list.find(period => period.id == value)?.notice)
				} }
			>
				{
					localList?.map((value) => {
						return (
							<Select.Option
								key={ value.id }
								value={ value.id }
							>
								{ MapDate(value.startDate, value.endDate) }
							</Select.Option>
						)
					})
				}
			</CustomSelect>
			<DatePicker
				allowClear={ allowYearPickerClear }
				className="select-accounting-year"
				picker="year"
				value={ year ? moment(year) : undefined }
				onChange={ (date) => {
					setYear(date)
					setComponentUpdated(true)
				} }
			/>
		</div>
	)
}
export default AccountingPeriod